'use strict';

module.exports = function(Chart) {

	Chart.Bubble = function(context, config) {
		config.type = 'bubble';
		return new Chart(context, config);
	};

};



//////////////////
// WEBPACK FOOTER
// ./node_modules/chart.js/src/charts/Chart.Bubble.js
// module id = 2411
// module chunks = 0